import * as yup from 'yup';
import { linkRegex } from 'utils';

export default ({ userStatus, isFedRAMPCustomer }) => {
  const cacheTest = (asyncValidate) => {
    let _valid = false;
    let _value = '';

    return async (value) => {
      if (value !== _value) {
        const response = await asyncValidate(value);
        _value = value;
        _valid = response;
        return response;
      }
      return _valid;
    };
  };

  let validationRule;
  if (isFedRAMPCustomer) {
    validationRule = 'fedramp';
  } else {
    validationRule = userStatus;
  }
  return {
    firstName: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.register.firstname')
        .test('firstName', 'ssp.field.firstname.invalid', (value) => !linkRegex.test(value)),
    lastName: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.register.lastname')
        .test('lastName', 'ssp.field.lastname.invalid', (value) => !linkRegex.test(value)),
  };
};
